export default __webpack_public_path__ + "static/media/MegaBit.0659c6d8.png";